import React, { FC, ReactChild } from "react";
import styled from "styled-components";
import Modal from "react-responsive-modal";

import Button from "../common/Button";
import { Additions } from "./ProductCard";

interface IAddAdditionsModal {
  open: boolean;
  setOpen: (value: boolean) => void;
  children: ReactChild;
  addToBasket: () => void;
  cleanAllChecked: () => void;
  additionsStatus: Additions;
  setAdditionsStatus: (value: Additions) => void;
}

const AddAdditionsModal: FC<IAddAdditionsModal> = ({
  open,
  setOpen,
  children,
  addToBasket,
  cleanAllChecked,
  additionsStatus,
  setAdditionsStatus,
}) => {
  const handleAdd = async () => {
    setOpen(false);
    await addToBasket();
    setAdditionsStatus(Additions.Empty);
    cleanAllChecked();
  };

  const handleClose = () => {
    setAdditionsStatus(Additions.Empty);
    cleanAllChecked();
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      classNames={{
        modal: "custom-modal custom-modal-wide",
        overlay:
          "custom-overlay custom-overlay-space-on-top custom-overlay-add-additions",
        closeButton: "custom-close",
      }}
      focusTrapped={false}
    >
      <Wrapper>
        <Title>Закажите салатик к картошке?</Title>
        <Inner>
          <WhiteShadowTop />
          <List>{children}</List>
          <WhiteShadowBottom />
        </Inner>
        <Button
          onClick={handleAdd}
          disabled={additionsStatus === Additions.Empty}
          primary
          full
        >
          ДОБАВИТЬ
        </Button>
        <Small onClick={handleAdd}>Спасибо, не надо</Small>
      </Wrapper>
    </Modal>
  );
};

const Wrapper = styled.div`
  padding: 38px 58px;

  @media (max-width: 48rem) {
    padding: 32px 24px 24px 24px;
  }

  @media (max-width: 20rem) {
    padding: 32px 12px 24px 12px;
  }
`;

const Title = styled.h4`
  font-size: 26px;
  line-height: 30px;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 32px;
  position: relative;
  z-index: 2;

  @media (max-width: 48rem) {
    max-width: 222px;
  }

  @media (max-width: 20rem) {
    font-size: 22px;
    line-height: 26px;
    margin-bottom: 32px;
  }
`;

const Inner = styled.div`
  position: relative;
`;

const WhiteShadowBottom = styled.div`
  position: absolute;
  left: 0;
  right: 16px;
  bottom: 0;
  background: linear-gradient(
    to top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.5) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  height: 64px;

  @media (max-width: 64rem) {
    right: 0;
  }
`;

const WhiteShadowTop = styled.div`
  position: absolute;
  left: 0;
  right: 16px;
  z-index: 2;
  top: 0;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  height: 32px;

  @media (max-width: 64rem) {
    right: 0;
  }
`;

const List = styled.ul`
  padding: 0;
  margin: 0;
  padding-top: 32px;
  padding-bottom: 24px;
  margin-top: -32px;

  overflow-x: hidden;
  overflow-y: auto;
  max-height: 550px;

  @media (max-width: 48rem) {
    max-height: calc(100vh - 246px);
  }

  @media (max-width: 20rem) {
    max-height: calc(100vh - 220px);
  }
`;

const Small = styled.button`
  display: block;
  margin: 0 auto;
  padding: 0;
  background: none;
  border: none;

  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #78b833;
  margin-top: 26px;
  cursor: pointer;

  transition: opacity 175ms ease-out;

  &:hover {
    opacity: 0.75;
  }

  @media (max-width: 20rem) {
    margin-top: 12px;
  }
`;

export default AddAdditionsModal;
